<div class="container border rounded pt-4">
	<div class="row text-center mb-2">
		<span class="theme-main-color fw-bold fs-4"> {{ title }} </span>
	</div>
	<div class="row">
		<div echarts [options]="chartOption"></div>
	</div>
</div>
